import { api } from '../../shared/lib/api';
import type { RegistrarVendaPayload, RegistrarVendaResponse } from './types';

export const pdvApi = {
  registrarVenda: (body: RegistrarVendaPayload) =>
    api.post<RegistrarVendaResponse>('vendas', body),
};
